import { useMutation, UseMutationConfig } from '@libs/use';
import { CreateSLTPOrderRequest } from '@libs/api-reference';

import * as API from '../requests';
import {
  CONDITIONAL_CREATION_HOUR,
  SLTP_ORDER_CLIENT_TAG,
  ORDER_SIDES,
  MAXIMUM_SLTP_SELL_QUANTITY_PERCENT,
  SLTP_QUANTITY_TYPE,
} from '../constants';

export type TCreateSLTPOrderFormModel = {
  upperTrigger: number | null;
  lowerTrigger: number | null;
  validityDate: number;
  orderExecutionType: string;
  percent: number;
};

type TSLTPOrderFactoryOptions = {
  formModel: TCreateSLTPOrderFormModel;
  isin: string;
};

type TUseCreateSLTPOrderOptions = {
  isin: string;
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

function SLTPOrderFactory({
  formModel,
  isin,
}: TSLTPOrderFactoryOptions): CreateSLTPOrderRequest {
  const today = new Date();

  return {
    instrumentIdentification: isin,
    orderSide: ORDER_SIDES.sell,
    bypassSellQuantity:
      formModel.percent === MAXIMUM_SLTP_SELL_QUANTITY_PERCENT,
    falconOrderQuantityType: SLTP_QUANTITY_TYPE.percent,
    percent: formModel.percent,
    upperTrigger: formModel.upperTrigger,
    lowerTrigger: formModel.lowerTrigger,
    orderExecutionType: formModel.orderExecutionType,
    clientTag: SLTP_ORDER_CLIENT_TAG,
    validityDate: new Date(
      new Date(
        today.setDate(today.getDate() + formModel.validityDate)
      ).setHours(CONDITIONAL_CREATION_HOUR, 59, 59)
    ),
  };
}

export default function useCreateSLTPOrderQuery({
  isin,
  onReject,
  onSuccess,
}: TUseCreateSLTPOrderOptions) {
  const {
    execute: createSLTPOrder,
    isPending: isLoadingCreateSLTPOrder,
    ...query
  } = useMutation<CreateSLTPOrderRequest>(
    ({ formModel }: { formModel: TCreateSLTPOrderFormModel }) =>
      API.createSLTPOrder(
        SLTPOrderFactory({
          formModel,
          isin,
        })
      ),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    createSLTPOrder,
    isLoadingCreateSLTPOrder,
    ...query,
  };
}
